import React from "react";

export const Pagination = ({
  pageNumber,
  totalPages,
  goToNextPageCallback,
  goToPreviousPageCallback,
  goToFirstPageCallback,
  goToLastPageCallback,
  setPageNumberCallback
}) =>
  totalPages > 1 && (
    <nav className="pagination">
      <div className="pagination__wrapper">
        <button
          onClick={goToPreviousPageCallback}
          disabled={pageNumber === 1}
          className="btn pagination__arrow pagination__arrow--left"
        >
          {"<<"}
        </button>

        <div className="pagination__numbers">
          {pageNumber > 2 && (
            <button
              onClick={goToFirstPageCallback}
              className="btn pagination__number pagination__dots"
            >
              ...
            </button>
          )}

          {pageNumber > 1 && (
            <button
              onClick={goToPreviousPageCallback}
              className="btn pagination__number"
            >
              {pageNumber - 1}
            </button>
          )}

          <button
            disabled
            onClick={setPageNumberCallback}
            className="btn pagination__number is-active"
          >
            {pageNumber}
          </button>

          {pageNumber < totalPages && (
            <button
              onClick={goToNextPageCallback}
              className="btn pagination__number"
            >
              {pageNumber + 1}
            </button>
          )}

          {totalPages - 1 > pageNumber && (
            <button
              onClick={goToLastPageCallback}
              className="btn pagination__number pagination__dots"
            >
              ...
            </button>
          )}
        </div>

        <button
          onClick={goToNextPageCallback}
          disabled={pageNumber === totalPages}
          className="btn pagination__arrow pagination__arrow--right"
        >
          {">>"}
        </button>
      </div>
    </nav>
  );



// WEBPACK FOOTER //
// ./src/components/Pagination.jsx